import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom"
import { Helmet } from "react-helmet-async";
import { config } from '../../config/env';
import Loader from "../../components/modal/Loader"
import Layout from "../../components/layout/Layout"
import BlogHeader from "../../components/blogheader/BlogHeader";
import FullImage from "../../components/fullimage/FullImage";
import MarkdownComponent from "../../components/markdowncomponent/MarkdownComponent";

const BlogByID = () => {
  const { id: contentBlogID } = useParams();
  const navigate = useNavigate();
  
  const [isLoading, setIsLoading] = useState(true);
  const [contentBlog, setContentBlog] = useState(null);
  
  useEffect(() => {
    const fetchBlog = async () => {
      setIsLoading(true)
      try {
        const response = await fetch(`${config.apiBaseUrl}/api/v1/content/blogs/${contentBlogID}`, {
          method: 'GET',
          headers: {
            "Content-Type": "application/json"
          }
        });

        if(!response.ok) {
          throw new Error('Failed to fetch blog content')
        }

        const data = await response.json()
        setContentBlog(data)
      }
      catch(error) {
        console.log('Error fetching blog content: ', error)
        navigate("/error/404")
      }
      finally {
        setIsLoading(false);
      }
    }
    fetchBlog()
  }, [])

  return (
    <div>
      <Helmet>
        <title>Avanade Research</title>
      </Helmet>
      <Layout>
        {
          contentBlog ? (
            <div>
              <BlogHeader
                  type={contentBlog.content_type.name}
                  title={contentBlog.title}
                  description={contentBlog.description}
                  date={new Date(contentBlog.created_at).toLocaleDateString()}
                  author={contentBlog.author}
              />
              <div className="mx-auto max-w-[920px] 2xl:max-w-[1400px]">
                <FullImage 
                  image={contentBlog.banner_image_url}
                />
              </div>
              <div className="mb-32 mx-auto max-w-[960px] 2xl:max-w-[1440px]">
                <MarkdownComponent 
                    markdownContent={contentBlog.content} 
                />
              </div>
            </div>
          ) : (<Loader />)
        }
      </Layout>
    </div>
  )
};

export default BlogByID;

